(() => {
  const DESIGN_STUDIO_PATH = '/pages/design-consultation';
  const DESIGN_STUDIO_LABELS = new Set(['design studio', 'design services', 'design consultation']);

  const updateLinkLabel = (link) => {
    const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      const normalizedText = textNode.textContent.trim().toLowerCase();

      if (normalizedText === 'design studio' || normalizedText === 'design services') {
        textNode.textContent = textNode.textContent.replace(/design (studio|services)/i, 'Design Consultation');
        return;
      }

      textNode = walker.nextNode();
    }
  };

  const updateDesignStudioLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const label = link.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      const href = link.getAttribute('href').toLowerCase();

      if (!DESIGN_STUDIO_LABELS.has(label) && !href.includes('/design-studio')) {
        return;
      }

      link.setAttribute('href', DESIGN_STUDIO_PATH);
      link.removeAttribute('target');
      updateLinkLabel(link);
    });
  };

  let updateQueued = false;
  const queueUpdate = () => {
    if (updateQueued) return;

    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      updateDesignStudioLinks();
    });
  };

  document.addEventListener('DOMContentLoaded', queueUpdate);
  window.addEventListener('load', queueUpdate);

  const observer = new MutationObserver(queueUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
